import { type IIconsVector } from 'shared/ui'
import { type internalAutomatedInfoType, type externalAutomatedInfoSource } from 'entities/Message'

export type internalAutomatedInfo = {
  isInternal: boolean
  source: externalAutomatedInfoSource | null
  type: internalAutomatedInfoType
  name: string | null
}

export type externalAutomatedInfo = {
  isInternal: boolean
  source: externalAutomatedInfoSource
  type: internalAutomatedInfoType | null
  name: string | null
}

export const automatedInfoIconMap: Record<
  internalAutomatedInfoType | externalAutomatedInfoSource,
  IIconsVector
> = {
  ai: 'chatBot',
  broadcast: 'broadcasts',
  campaign: 'campaigns',
  keyword: 'keywords',
  triggers: 'lightning2',
  workflows: 'workflows',
  workflow_survey: 'clipboardCheck',
  hubspot: 'hubspot',
  activeCampaign: 'activecampaign',
  keap: 'infusionsoft',
  pipedrive: 'pipedrive',
  salesforce: 'salesforce',
  zapier: 'zapier',
  make: 'make',
  salesmessage: 'salesmessage',
}

export const automatedInfoTitleMap: Record<
  internalAutomatedInfoType | externalAutomatedInfoSource,
  string
> = {
  ai: 'AI Agent',
  broadcast: 'Broadcast',
  campaign: 'Campaign',
  keyword: 'Keyword',
  triggers: 'Trigger',
  workflows: 'Workflow',
  workflow_survey: 'Survey',
  hubspot: 'HubSpot',
  activeCampaign: 'ActiveCampaign',
  keap: 'Keap',
  pipedrive: 'Pipedrive',
  salesforce: 'Salesforce',
  zapier: 'Zapier',
  make: 'Make',
  salesmessage: 'Salesmessage',
}

export type automatedInfo = internalAutomatedInfo | externalAutomatedInfo
